import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface TestData {
    id: number;
    title: string;
    selectedGroupId: string[];
    selectedStudentIds: string[];
    published: boolean;
    available: number;
}

interface ResponseAddTestState {
    success: boolean;
    error: string | null;
    errors: {
        [key: string]: string[];
    };
    data: TestData;
}

const initialState: ResponseAddTestState = {
    success: false,
    error: null,
    errors: {},
    data: {
        id: 0,
        title: "",
        selectedGroupId: [],
        selectedStudentIds: [],
        published: false,
        available: 1,
    },
};

const responseAddTestSlice = createSlice({
    name: "responseAddTest",
    initialState,
    reducers: {
        setModel: (state, action: PayloadAction<TestData>) => {
            state.data = action.payload;
            state.success = true;
            state.error = null;
            state.errors = {};

        },
        setErrors: (
            state,
            action: PayloadAction<{
                success: boolean;
                error: string;
                errors: { [key: string]: string[] };
            }>
        ) => {
            state.error = action.payload.error;
            state.errors = action.payload.errors;
            state.success = action.payload.success;
        },
    },
});

export const { setErrors, setModel } = responseAddTestSlice.actions;

export const responseAddTestReducer = responseAddTestSlice.reducer;
